<template>
  <div>
    <!-- 标签 -->
    <div v-if="formKey === 'label'">
      <div v-if="formItem.isPreview">
        <div v-if="formItem.value.length">
          <el-tag
            v-for="(tag, i) in formItem.value"
            :key="i"
            class="mr-10"
          >{{ tag.content }}</el-tag>
        </div>
        <div v-else>-</div>
      </div>
      <div v-else>
        <el-button type="primary" size="mini" @click="formItem.is_show = true">添加标签</el-button>
        <div v-if="formItem.value.length" class="tags-wrapper mt-10">
          <el-tag
            v-for="(tag, i) in formItem.value"
            :key="i"
            class="mr-10"
            disable-transitions
            closable
            @close="formItem.value.splice(i, 1)"
          >{{ tag.content }}</el-tag>
        </div>
      </div>
      <tags
        v-if="formItem.is_show"
        :is-open="formItem.is_show"
        :data="formItem.value"
        :advertiser-id="advertiser_id"
        @cancel="formItem.is_show = false"
        @confirm="(data) => tagsConfirm(data, formItem)"
      />
    </div>
    <!-- 试玩页 -->
    <div v-if="formKey === 'wxgame_playable_page_path'">
      <div class="flex items-center">
        <el-button v-if="!formItem.isPreview" type="primary" @click="() => openAssignWxgamePlayablePagePath(formItem)">选择小游戏试玩页</el-button>
        <i v-if="Object.keys(formItem.value || {}).length" class="el-icon-success app-check-icon-success" :class="{ 'ml-10': !formItem.isPreview }" />
      </div>
      <div v-if="!Object.keys(formItem.value || {}).length && formItem.isPreview">-</div>
      <el-dialog
        title="小游戏试玩页配置"
        :visible.sync="formItem.is_open"
        :close-on-click-modal="false"
        :append-to-body="true"
        :modal-append-to-body="true"
        width="800px"
      >
        <wxgame-playable-page-path :key="Date.now()" :form-item="formItem" />
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="formItem.is_open = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="() => confirmAssignWxgamePlayablePagePath(formItem)">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 试玩结束封面图 -->
    <div v-if="formKey === 'wxgame_playable_page_end_cover_img'">
      <div class="flex">
        <el-image v-show="formItem.value" class="mr-10 icon inline-block" fit="cover" :src="formItem.value" />
        <div>
          <el-button v-if="!formItem.isPreview" size="mini" type="primary" @click="openMaterialBox('image', formItem)">{{ formItem.value ? '替换' : '添加' }}封面</el-button>
        </div>
      </div>
      <!-- 素材弹框 -->
      <material-box
        v-if="formItem.is_open"
        advertiser="gdt"
        :is-open="formItem.is_open"
        :type="formItem.box_type"
        :temp-material="formItem.temp_material"
        :material-restriction="formItem.material_restriction"
        @confirm="(m_data) => materialConfirm({ data: m_data, material: formItem })"
        @cancel="materialCancel(formItem)"
      />
    </div>
  </div>
</template>

<script>
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';
import { component_props } from '@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/model/props';

export default {
  components: {
    'material-box': () => import('@/components/material-box'),
    'tags': () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/creative-config/creative-components/channel-interface/gdt/components/tags.vue'),
    'wxgame-playable-page-path': () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/creative-config/creative-components/channel-interface/gdt/components/wxgame-playable-page-path/index.vue'),
  },
  mixins: [data_sharing_mixin],
  props: {
    ...component_props,
  },
  computed: {
    advertiser_id() {
      const { advertiser_ids } = this.initOps;
      return advertiser_ids[0];
    },
  },
  methods: {
    /**
     * 标签确认
     * @param {Object[]} data 标签数据
     * @param {Object} form_item 表单项
     * @returns {void}
     */
    tagsConfirm(data, form_item) {
      form_item.value = data;
      this.$parent.$parent.$parent.validateField('label.value');
    },
    /**
     * 打开试玩页配置
     * @param form_item 表单项
     * @returns {void}
     */
    openAssignWxgamePlayablePagePath(form_item) {
      form_item.assignSelection = JSON.parse(JSON.stringify(form_item.value));
      form_item.is_open = true;
    },
    /**
     * 试玩页配置弹窗确认
     * @param form_item 表单项
     * @returns {void}
     */
    confirmAssignWxgamePlayablePagePath(form_item) {
      const result = JSON.parse(JSON.stringify(form_item.assignSelection));
      const { config: { init_ops: { advertiser_ids }}} = this.local_sharing_data.getFormContext();
      const is_valid = advertiser_ids.every(advertiser_id => result[advertiser_id]?.length);
      if (is_valid) {
        form_item.value = JSON.parse(JSON.stringify(form_item.assignSelection));
        form_item.is_open = false;
        form_item?.on?.change?.(form_item.value);
        this.$parent.$parent.$parent.$parent.$parent.validateField('wxgame_playable_page.children.wxgame_playable_page_path.value');
      } else {
        this.$message.warning('请填写完整所有配置');
      }
    },
    /**
     * 打开素材框
     * @param {string} type 素材类型
     * @param {string} material_item 当前素材
     * @returns {void}
     */
    openMaterialBox(type, material_item) {
      if (material_item) {
        material_item.temp_material = null;
        material_item.is_open = true;
        material_item.box_type = material_item.element_type || type;
      }
    },
    /**
     * 素材资源确定返回
     * @param {Array<Object>} data 素材数据
     * @param {Object} material 表单配置项
     * @returns {void}
     */
    async materialConfirm({ data, material }) {
      material.is_open = false;

      if (data.length === 0) {
        return;
      }

      if ((data.length > material.limit) && !material.temp_material) {
        this.$message.warning(`试玩结束封面图不能超过${material.limit}个！`);
        return;
      }
      material.value = data[0].url[0].url;
      this.$parent.$parent.$parent.$parent.$parent.validateField('wxgame_playable_page.children.wxgame_playable_page_end_cover_img.value');
    },
    /**
     * 素材资源取消返回
     * @param {Object} material 素材配置项
     * @returns {void}
     */
    materialCancel(material) {
      material.is_open = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.tags-wrapper {
  padding: 10px;
  background: rgba(0, 0, 0, 0.02);
}
.icon {
  width: 100px;
  height: 100px;
  font-size: 0;
}
</style>
